import { render, staticRenderFns } from "./TransacoesAvulsaModal.vue?vue&type=template&id=116b68dc&"
import script from "./TransacoesAvulsaModal.vue?vue&type=script&lang=js&"
export * from "./TransacoesAvulsaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports